// extracted by mini-css-extract-plugin
export default {"TableContainer":"FaultTable_TableContainer__OsoQ-"};